module.exports = __webpack_public_path__ + "static/media/alishan_package.f8a156dc.webp";